import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Basic Details',
  attributeName: 'sourceFilesFormGroup',
  
  fields: [
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Name',
      label: 'Name',
      // required: true,
      helpText: 'Name to identify the job in the XMS.',
      errorText: '',
    },    
    {
      attributeName: 'region',
      label: 'Region',
      type: FormInputTypes.SELECT,
      width: '400px',
      options: [
        {value:"-1",name:"(Select or write an option)"},
        {value:"AF-SOUTH-1",name:"AWS AF-SOUTH-1 - Africa (Cape Town)"},
        {value:"AP-EAST-1",name:"AWS AP-EAST-1 - Asia Pacific (Hong Kong) "},
        {value:"AP-NORTHEAST-1",name:"AWS AP-NORTHEAST-1 - Asia Pacific (Tokyo)"},
        {value:"AP-NORTHEAST-2",name:"AWS AP-NORTHEAST-2 - Asia Pacific (Seoul)"},
        {value:"AP-NORTHEAST-3",name:"AWS AP-NORTHEAST-3 - Asia Pacific (Osaka)"},
        {value:"AP-SOUTH-1",name:"AWS AP-SOUTH-1 - Asia Pacific (Mumbai)"},
        {value:"AP-SOUTHEAST-1",name:"AWS AP-SOUTHEAST-1 - Asia Pacific (Singapore)"},
        {value:"AP-SOUTHEAST-2",name:"AWS AP-SOUTHEAST-2 - Asia Pacific (Sydney)"},
        {value:"AP-SOUTHEAST-3",name:"AWS AP-SOUTHEAST-3 -  Asia Pacific (Jakarta)"},
        {value:"CA-CENTRAL-1",name:"AWS CA-CENTRAL-1 - Canada (Central)"},
        {value:"EU-CENTRAL-1",name:"AWS EU-CENTRAL-1 - Europe (Frankfurt)"},
        {value:"EU-NORTH-1",name:"AWS EU-NORTH-1 - Europe (Stockholm)"},
        {value:"EU-SOUTH-1",name:"AWS EU-SOUTH-1 - Europe (Milan)"},
        {value:"EU-WEST-1",name:"AWS EU-WEST-1 - Europe (Ireland)"},
        {value:"EU-WEST-2",name:"AWS EU-WEST-2 - Europe (London)"},
        {value:"EU-WEST-3",name:"AWS EU-WEST-3 - Europe (Paris)"},
        {value:"ME-SOUTH-1",name:"AWS ME-SOUTH-1 - Middle East (Bahrain)"},
        {value:"SA-EAST-1",name:"AWS SA-EAST-1 - South America (São Paulo)"},
        {value:"US-EAST-1",name:"AWS US-EAST-1 - US East (N. Virginia)"},
        {value:"US-EAST-2",name:"AWS US-EAST-2 - US East (Ohio)"},
        {value:"US-WEST-1",name:"AWS US-WEST-1 - US West (N. California)"},
        {value:"US-WEST-2",name:"AWS US-WEST-2 - US West (Oregon)"},
        {value:"asia-east1-a",name:"GCP asia-east1-a - Asia Pacific (Taiwan)"},
        {value:"asia-east1-b",name:"GCP asia-east1-b - Asia Pacific (Taiwan)"},
        {value:"asia-east1-c",name:"GCP asia-east1-c - Asia Pacific (Taiwan)"},
        {value:"asia-east2-a",name:"GCP asia-east2-a - Asia Pacific (Hong Kong)"},
        {value:"asia-east2-c",name:"GCP asia-east2-c - Asia Pacific (Hong Kong)"},
        {value:"asia-northeast1-a",name:"GCP asia-northeast1-a - Asia Pacific (Japan)"},
        {value:"asia-northeast1-c",name:"GCP asia-northeast1-c - Asia Pacific (Japan)"},
        {value:"asia-northeast3-a",name:"GCP asia-northeast3-a - Asia Pacific (South Korea)"},
        {value:"asia-northeast3-b",name:"GCP asia-northeast3-b - Asia Pacific (South Korea)"},
        {value:"asia-northeast3-c",name:"GCP asia-northeast3-c - Asia Pacific (South Korea)"},
        {value:"asia-south1-a",name:"GCP asia-south1-a - Asia Pacific (India)"},
        {value:"asia-south1-b",name:"GCP asia-south1-b - Asia Pacific (India)"},
        {value:"asia-southeast1-a",name:"GCP asia-southeast1-a - Asia Pacific (Singapur)"},
        {value:"asia-southeast1-b",name:"GCP asia-southeast1-b - Asia Pacific (Singapur)"},
        {value:"asia-southeast1-c",name:"GCP asia-southeast1-c - Asia Pacific (Singapur)"},
        {value:"australia-southeast1-a",name:"GCP australia-southeast1-a - Asia Pacific (Australia)"},
        {value:"australia-southeast1-b",name:"GCP australia-southeast1-b - Asia Pacific (Australia)"},
        {value:"australia-southeast1-c",name:"GCP australia-southeast1-c - Asia Pacific (Australia)"},
        {value:"europe-southwest1",name:"GCP europe-southwest1 - Europe (Madrid)"},
        {value:"europe-west1-b",name:"GCP europe-west1-b - Europe (Belgium)"},
        {value:"europe-west1-c",name:"GCP europe-west1-c - Europe (Belgium)"},
        {value:"europe-west1-d",name:"GCP europe-west1-d - Europe (Belgium)"},
        {value:"europe-west2-a",name:"GCP europe-west2-a - Europe (England)"},
        {value:"europe-west2-b",name:"GCP europe-west2-b - Europe (England)"},

        {value:"europe-west3-a",name:"GCP europe-west3-a - Europe (Germany)"},
        {value:"europe-west3-b",name:"GCP europe-west3-b - Europe (Germany)"},
        {value:"europe-west3-c",name:"GCP europe-west3-c - Europe (Germany)"},

        {value:"europe-west4-a",name:"GCP europe-west4-a - Europe (Netherlands)"},
        {value:"europe-west4-b",name:"GCP europe-west4-b - Europe (Netherlands)"},
        {value:"europe-west4-c",name:"GCP europe-west4-c - Europe (Netherlands)"},
        {value:"northamerica-northeast1-a",name:"GCP northamerica-northeast1-a - North America (Canada)"},
        {value:"northamerica-northeast1-b",name:"GCP northamerica-northeast1-b - North America (Canada)"},
        {value:"northamerica-northeast1-c",name:"GCP northamerica-northeast1-c - North America (Canada)"},
        {value:"southamerica-east1-c",name:"GCP southamerica-east1-c - South America (Brazil)"},
        {value:"southamerica-west1-a",name:"GCP southamerica-west1-a - South America (Chile)"},
        {value:"southamerica-west1-b",name:"GCP southamerica-west1-b - South America (Chile)"},
        {value:"southamerica-west1-c",name:"GCP southamerica-west1-c - South America (Chile)"},
        {value:"us-central1-a",name:"GCP us-central1-a - US Central (Iowa)"},
        {value:"us-central1-b",name:"GCP us-central1-b - US Central (Iowa)"},
        {value:"us-central1-c",name:"GCP us-central1-c - US Central (Iowa)"},
        {value:"us-central1-f",name:"GCP us-central1-f - US Central (Iowa)"},
        {value:"us-east1-b",name:"GCP us-east1-b - US East (South Carolina)"},
        {value:"us-east1-c",name:"GCP us-east1-c - US East (South Carolina)"},
        {value:"us-east1-d",name:"GCP us-east1-d - US East (South Carolina)"},
        {value:"us-east4-a",name:"GCP us-east4-a - US East (Virginia)"},
        {value:"us-east4-b",name:"GCP us-east4-b - US East (Virginia)"},
        {value:"us-east4-c",name:"GCP us-east4-c - US East (Virginia)"},
        {value:"us-west1-a",name:"GCP us-west1-a - US West (Oregon)"},
        {value:"us-west2-b",name:"GCP us-west2-b - US West (California)"},
        {value:"us-west2-c",name:"GCP us-west2-c - US West (California)"},
        {value:"us-west4-a",name:"GCP us-west4-a - US West (Nevada)"},
        {value:"us-west4-b",name:"GCP us-west4-b - US West (Nevada)"},
      ],
      helpText: 'Type of AWS/GCS Region for deployment.',
      
    },
    
    {
      attributeName: 'originType',
      type: FormInputTypes.SELECT,
      label: 'Origin type',
      helpText: 'Select location of the input file',
      errorText: '',
      canEdit: true,
      disabled:true,
      options: [
        { name: 'Choose Origin Type', value: 'undefined'},
        { name: 'SFTP', value: 'SFTP' },
        { name: 'S3', value: 'S3' },
        { name: 'GCS', value: 'GCS' },
        { name: 'WASABI', value: 'WASABI' }
        
      ],
    },
    
  ],
};
